import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectCurrentToken, selectLicenseExpired } from "./authSlice"

const RequireAuth = () => {
    const token = useSelector(selectCurrentToken)
    const licenseExpired = useSelector(selectLicenseExpired)
    const location = useLocation()

    return (
        token
            ? (licenseExpired
                ? <Navigate to="/dashboard/license" state={{ from: location }} replace />
                : <Outlet />)
            : <Navigate to="/login" state={{ from: location }} replace />
    )
}
export default RequireAuth